import { Flex, ModalV2, QueryLoader, Text } from "@jsq/ds/core";
import { Form, FormTextInput, FormSelect, SubmitButton, CancelButton } from "@jsq/ds/forms";
import { useFetchCanopyRolesData } from "~/pages/UserAndRoles/CanopyRolesPage/hooks";
import { FormValues, CanopyRoleData } from "./hooks";
import { validationSchema } from "./schema";
import { footerStyles, formBodyStyles, selectStyles } from "./styles_vanilla.css";

type CreateUserModalProps = {
  show: boolean;
  onHide: () => void;
  initialValues: FormValues;
  onSubmit: (values: Partial<FormValues>) => Promise<void>;
  isSubmitting: boolean;
  roleOptions: CanopyRoleData[];
  useGetGroupsQueryResult: ReturnType<
    typeof useFetchCanopyRolesData
  >["useGetGroupsQueryResult"];
};

export const CreateUserModal = ({
  show,
  onHide,
  initialValues,
  onSubmit,
  isSubmitting,
  roleOptions,
  useGetGroupsQueryResult,
}: CreateUserModalProps) => {
  return (
    <ModalV2 show={show} onHide={onHide} title="Add new user" data-testid="create-user-modal">
      <Form
        initialValues={initialValues}
        yupValidationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnBlur={false}
      >
        <ModalV2.Body className={formBodyStyles}>
          <FormTextInput
            name="firstName"
            label="First name"
            placeholder="Enter first name"
            disabled={isSubmitting}
            isFullWidth
          />
          <FormTextInput
            name="lastName"
            label="Last name"
            placeholder="Enter last name"
            disabled={isSubmitting}
            isFullWidth
          />
          <FormTextInput
            name="email"
            label="Email address"
            placeholder="Enter email address"
            type="email"
            disabled={isSubmitting}
            isFullWidth
          />
          <QueryLoader result={useGetGroupsQueryResult}>
            <Flex flexDirection="column">
              <FormSelect
                name="role"
                placeholder="Select Canopy role..."
                className={selectStyles}
                label={"Role"}
                data-testid="role-select"
              >
                <FormSelect.Section>
                  {roleOptions.map((role, idx) => (
                    <FormSelect.Option
                      value={role.id}
                      key={role.id}
                      data-testid={`role-item-${idx + 1}`}
                    >
                      {role.title}
                    </FormSelect.Option>
                  ))}
                </FormSelect.Section>
              </FormSelect>
              <Text variant="secondary-sm">
                Additional roles can be added after you add this new user
              </Text>
            </Flex>
          </QueryLoader>
        </ModalV2.Body>

        <ModalV2.Footer className={footerStyles}>
          <CancelButton onClick={onHide} disabled={isSubmitting}>
            Cancel
          </CancelButton>
          <SubmitButton
            isLoading={isSubmitting}
            disabled={isSubmitting}
            data-testid="add-new-user-button"
          >
            Add new user
          </SubmitButton>
        </ModalV2.Footer>
      </Form>
    </ModalV2>
  );
};
